import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import type { ContentItem } from '../types/AppContent';
import type { StoreType } from './index';
import { getMindItems } from './mindItems.selectors';
import type { PinnedContentArray } from './pinned.reducers';
import { getProducts } from './products.selectors';
import { getContent } from './selectorHelpers';

const getPinnedContents = (state: StoreType): PinnedContentArray => state.pinned.contents;

export const selectPinnedStatus = (state: StoreType): AsyncActionStatus => state.pinned.status;

export const selectPinnedPagination = (state: StoreType) => state.pinned.pagination;

export const selectPinnedContents = createSelector(
	[getPinnedContents, getMindItems, getProducts],
	(pinned, mindItems, products) =>
		pinned
			.map((i) => getContent(i.type, i.id, mindItems, products))
			.filter((v) => !!v) as ContentItem[]
);

export const selectPinnedCount = (state: StoreType) =>
	state.pinned.pagination.total < 0 && state.pinned.status !== AsyncActionStatus.READY
		? undefined
		: state.pinned.pagination.total;

export const usePinnedStatus = (): AsyncActionStatus => {
	return useSelector((state: StoreType) => state.pinned.status);
};

export const usePinnedContents = (): ContentItem[] =>
	useSelector(({ pinned, mindItems, products }: StoreType) =>
		pinned.contents
			.map(({ type, id }) => getContent(type, id, mindItems.byId, products.byId))
			.filter((item): item is ContentItem => Boolean(item))
	);
